// Barakali — variant. Renders /templates/barakali.html (Soft Bloom
// birthday, paper + sage + teal + gold) inside a full-bleed iframe.
// The HTML's customizer reads names/date/time/venue/address/phone/music
// from the query string.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/barakali.html";

export function BarakaliStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  // Birthday: a single name, but we still pass via "names".
  if (t.names) params.set("names", t.names.split(/\s*&\s*/)[0].trim());
  if (t.date) {
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  // Per-row extras surfaced via the editor — see data.ts b04.
  const age = typeof t.custom?.age === "string" ? t.custom.age.trim() :
              typeof t.custom?.age === "number" ? String(t.custom.age) : "";
  if (age) params.set("age", age);
  const phone = typeof t.custom?.phone === "string" ? t.custom.phone.trim() : "";
  if (phone) params.set("phone", phone);
  if (ctx.slug) params.set("slug", ctx.slug);
  // ?audio=/music/<id>.mp3 — owner-picked soundtrack from the
  // curated MusicSelector library. Empty/unset = silent card.
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Barakali"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F5EFE6",
      }}
    />
  );
}
